<ng-container *ngIf="dialog$ | async as dialog">
  <div class="modal-dialog-container contact-us-container paybee-modal-content">
    <div class="modal-header">
      <div class="step-title">Contact us</div>
    </div>
    <div class="modal-body" [formGroup]="form">
      <div class="row field-container">
        <div class="col-12">
          <mdb-form-control class="form-fill" *ngIf="!loggedIn" >
            <app-mdbp-input mdbInput formControlName="name"  label='Name'></app-mdbp-input>
            <span class="form-fill-error"  *ngIf="form.controls.name.touched && form.controls.name.invalid ">{{ getErrorMessage('name') }}</span>
        </mdb-form-control>

          <mdb-form-control class="form-fill" *ngIf="!loggedIn" >
            <app-mdbp-input mdbInput formControlName="email"  label='Email'></app-mdbp-input>
            <span class="form-fill-error"  *ngIf="form.controls.email.touched && form.controls.email.invalid ">Please provide email</span>
        </mdb-form-control>

          <mdb-form-control class="form-fill" >
            <app-mdbp-input mdbInput formControlName="subject"  label='Subject'></app-mdbp-input>
            <span class="form-fill-error"  *ngIf="form.controls.subject.touched && form.controls.subject.invalid ">{{ getErrorMessage('subject') }}</span>
        </mdb-form-control>

          <mdb-form-control class="form-fill textarea-control"  >
            <app-mdb-textarea mdbInput formControlName="message" maxLength="128" label="Message"></app-mdb-textarea>
            <span class="form-fill-error"  *ngIf="form.controls.message.invalid && form.controls.message.touched">{{ getErrorMessage('message') }}</span>
        </mdb-form-control>
        </div>
      </div>
    </div>
    <div class="modal-footer paybee-modal-footer">
      <div class="row">
        <div class="col text-right">
          <button type="button" class="btn btn-sm modal-cancel-button close-action" (click)="close(dialog, true)">Close</button>
          <button type="button" class="btn btn-sm modal-confirm-button confirm-action" (click)="confirm(dialog, true)">Send</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
